import { SideNav } from "../../components/Layout/SideNav";
import {
  SidebarInset,
  // SidebarTrigger,
  SidebarProvider,
} from "../../components/shadcn-ui/sidebar";
import { Outlet, useLocation } from "react-router-dom";
import { FloatingButton } from "../../features/salesHubDashboard/FloatingButton";
import { SiteHeader } from "../../components/Layout/SiteHeader";

export const Dashboard = () => {
  const { pathname } = useLocation();

  return (
    <SidebarProvider>
      <SidebarInset className="overflow-x-hidden">
        <SiteHeader />
        <div className="md:flex flex-1 gap-4 pt-0 bg-gray-200 bg-opacity-50 overflow-x-hidden min-h-[calc(100vh-64px)]">
          <div>
            {pathname !== "/dashboard" && pathname !== "/dashboard/" && (
              <SideNav />
            )}
            {/* Will see if we need a toggleable side nav or not */}
            {/* {pathname !== "/dashboard" && <SidebarTrigger className="-ml-1" />} */}
          </div>
          <div className="flex-1 p-4 md:pl-3 pb-3 md:pt-5">
            <Outlet />
          </div>
          <FloatingButton />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};
